export const SET_PRODUCTIONS_LOADING = "SET_PRODUCTIONS_LOADING";
export const CLEAR_PRODUCTIONS_STORE = "CLEAR_PRODUCTIONS_STORE";
export const SET_PRODUCTIONS_DATA = "SET_PRODUCTIONS_DATA";
export const SET_PRODUCTIONS_FILTER = "SET_PRODUCTIONS_FILTER";
export const SET_KITCHEN_SECTION = "SET_KITCHEN_SECTION";
